"use strict";

angular.module("core").factory("BtnOrderService", function($http, appConfig) {
    var orderingUrl;

    function _updateOrder(id, moveAction) {
        var moveActionIgnoringLoading = ["up", "down"];
        return $http({
            method: "PATCH",
            ignoreLoadingBar: moveActionIgnoringLoading.indexOf(moveAction) >= 0,
            url: appConfig.API_SERVER + "/" + orderingUrl + "/" + id + "/",
            data: {
                move: moveAction
            }
        });
    }

    return {
        setOrderUrl: function(url) {
            orderingUrl = url;
        },
        moveUp: function(id) {
            return _updateOrder(id, "up");
        },
        moveDown: function(id) {
            return _updateOrder(id, "down");
        },
        moveTop: function(id) {
            return _updateOrder(id, "top");
        },
        moveBottom: function(id) {
            return _updateOrder(id, "bottom");
        },
        moveTo: function(id, position) {
            return $http({
                method: "PATCH",
                ignoreLoadingBar: true,
                url: appConfig.API_SERVER + "/" + orderingUrl + "/" + id + "/",
                data: {
                    to: position
                }
            });
        },
        createSequence: function(catalogId, field, direction) {
            return $http({
                method: "POST",
                ignoreLoadingBar: true,
                url: appConfig.API_SERVER + "/catalog/customer/create-sequence/",
                data: {
                    catalog: catalogId,
                    field: field,
                    direction: direction
                }
            });
        }
    }
})

.component("btnOrdered", {
    templateUrl: require("./btn-ordered.component.html"),
    css: require("./btn-ordered.component.scss"),
    bindings: {
        pagination: "=",
        first: "<",
        last: "<",
        index: "<",
        item: "=",
        itemList: "=",
        refreshFunction: "&",
        url: "@",
        ordering: "=",
        scroll: "<?",
        createSequence: "=?",
        currentOrdering: "<?",
        catalogId: "<?"
    },
    controller: function($scope, BtnOrderService, $q, $timeout, common) {
        var _this = this;

        $scope.$watch(
            function() {
                return _this.itemList;
            },
            function(newValue, oldValue) {
                _setItemsOrderIndex();
            }
        );

        BtnOrderService.setOrderUrl(this.url);

        function _createSequence() {
            var deferred = $q.defer();

            if (_this.createSequence && !_this.createSequence.value && _this.catalogId) {
                var field = common.getSortField(_this.currentOrdering);
                var direction = common.getSortDirection(_this.currentOrdering);

                BtnOrderService.createSequence(_this.catalogId, field, direction).then(function() {
                    _this.createSequence.value = true;
                    deferred.resolve(true);
                }, function() {
                    deferred.reject(true);
                });
            }
            else {
                deferred.resolve(true);
            }

            return deferred.promise;
        }

        function _setItemsOrderIndex() {
            var pageSize = _this.pagination.page_size;
            var currentPage = (_this.pagination.current_page) ? _this.pagination.current_page : 1;
            var firstIndex = (currentPage === 1 || _this.scroll) ? 1 : (pageSize * (currentPage - 1)) + 1;

            common.setItemOrderIndex(firstIndex, _this.itemList);
        }

        function _moveOnce(serviceMethod, direction, index, reference) {
            if (_this.ordering.isFetching)
                return;

            _this.ordering.isFetching = true;
            var promise = _createSequence();

            promise.then(function() {
                var itemToMove = _this.itemList[index];
                if (itemToMove) {
                    var itemId = itemToMove.id;
                    var itemOrderIndex = _this.itemList[index].orderIndex;

                    if (!reference || _this.scroll) {
                        _this.itemList[index] = _this.itemList[index + direction];
                        _this.itemList[index + direction] = itemToMove;

                        _this.itemList[index].orderIndex = itemOrderIndex
                        _this.itemList[index + direction].orderIndex = itemOrderIndex + direction;
                    }
                    return serviceMethod(itemId);
                }
                return serviceMethod(null);
            }).then(function() {
                if (reference)
                    _this.refreshFunction();
            }).finally(function() {
                _this.ordering.isFetching = false;
            });
        }

        function _moveLimit(serviceMethod, index) {
            if (_this.ordering.isFetching)
                return;

            _this.ordering.isFetching = true;
            var promise = _createSequence();

            promise.then(function() {
                var itemToMove = _this.itemList[index];
                if (itemToMove) {
                    var itemId = itemToMove.id;
                    return serviceMethod(itemId);
                }
                return serviceMethod(null);
            }).then(function() {
                _this.refreshFunction();
            }).finally(function() {
                _this.ordering.isFetching = false;
            });
        }

        this.hasError = function(form, itemId) {
            var orderForm = form[itemId];
            var orderInputErrors = orderForm["orderIndex" + itemId].$error;
            return orderForm.$submitted && (orderInputErrors.required || orderInputErrors.min || orderInputErrors.max);
        };

        this.focusInput = function(itemId) {
            var itemInput = angular.element("#order-index-" + itemId);
            if (itemInput) {
                $timeout(function() {
                    itemInput.focus();
                    itemInput.select();
                }, 50);
            }
        };

        this.isFirst = function(first) {
            return first && (!this.pagination.current_page || this.pagination.current_page == 1 || this.scroll);
        };

        this.isLast = function(last) {
            return last && ((!this.pagination.current_page && this.pagination.num_pages == 1) || this.pagination.current_page == this.pagination.num_pages);
        };

        this.moveUp = function(first, index) {
            _moveOnce(BtnOrderService.moveUp, -1, index, first);
        };

        this.moveDown = function(last, index) {
            _moveOnce(BtnOrderService.moveDown, 1, index, last);
        };

        this.moveTop = function(index) {
            _moveLimit(BtnOrderService.moveTop, index);
        };

        this.moveBottom = function(index) {
            _moveLimit(BtnOrderService.moveBottom, index);
        };

        this.moveTo = function(item, form) {
            if (item.initialOrderIndex == item.orderIndex || _this.ordering.isFetching)
                return;

            _this.ordering.isFetching = true;
            var promise = _createSequence();
            promise.then(function() {
                if (form.$valid) {
                    var itemOrderIndex = item.orderIndex;
                    var itemId = item.id;

                    return BtnOrderService.moveTo(itemId, itemOrderIndex)
                }
            }).then(function() {
                if (form.$valid) {
                    _this.refreshFunction();
                }
            }).finally(function() {
                _this.ordering.isFetching = false;
            });
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./core/btn-ordered/btn-ordered.component.js
// module id = 560
// module chunks = 0